<div class="edit-role-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">Edit Role</h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="onCancel()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    <p class="dialog-message">
      Change the role for <strong>{{ data.userName }}</strong
      >:
    </p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Role</mat-label>
      <mat-select [(ngModel)]="selectedRoleId">
        @for (role of data.roles; track role.id) {
          <mat-option [value]="role.id" [disabled]="isRoleDisabled(role)">
            {{ role.name }}
          </mat-option>
        }
      </mat-select>
      @if (data.canAssignOperatorRole === false) {
        <mat-hint>
          {{ getOperatorRoleBlockedMessage() }}
        </mat-hint>
      }
    </mat-form-field>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <button class="cancel-button" (click)="onCancel()">Cancel</button>
    <button class="save-button" (click)="onConfirm()">Save</button>
  </div>
</div>
